<template>
  <v-card class="mx-auto" max-width="600" elevation="0">
    <v-card-text class="py-0">
      <v-timeline align-top dense>
        <v-timeline-item color="pink" small>
          <v-row class="pt-1" style="overflow-x: auto;flex-wrap: nowrap">
            <v-col cols=4>
              <strong>{{ item.__t }}</strong>
            </v-col>
            <v-col cols=6>
              <p>{{ item.state }}</p>
              <div class="caption">
                <v-chip class="pa-3" text-color="white" :color="getColor(item.createdAt, item.state)">
                  <div v-if="item.state === 'created'">{{ formatDate(item.createdAt) }}</div>
                  <div v-else>{{ formatDate(item.updatedAt) }}</div>
                </v-chip>
              </div>
            </v-col>
            <v-col cols=3 >
            <v-btn v-if="item.responseFromKiosk !== null" @click="handleDownloadClick(item)" icon color="pink">
              <v-icon>mdi-cloud-download-outline </v-icon>
            </v-btn>

            <template v-else-if="item.state === 'created' && item.__t !== 'AutoDiagJob'">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn @click="showConfirmDialog = true" icon color="red" v-bind="attrs" v-on="on">
                    <v-icon>mdi-minus-circle</v-icon>
                  </v-btn>
                </template>
                <span>Delete job</span>
              </v-tooltip>
            </template>
            <v-dialog v-model="showConfirmDialog" max-width="400">
            <v-card>
              <v-card-title class="headline">Confirm Deletion</v-card-title>
              <v-card-text>
                Are you sure you want to delete this job?
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text color="grey" @click="showConfirmDialog = false">
                  No
                </v-btn>
                <v-btn text color="red" @click="removeJob(item)">
                  Yes
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          </v-col>
          </v-row>
        </v-timeline-item>
      </v-timeline>
    </v-card-text>
  </v-card>
</template>
<script>
import { niceDateTimeFormat } from '@/utils/DateFormatter';
export default {
  props: {
    item: Object,
  },
  data() {
    return {
      showConfirmDialog: false,
    }
  },
  methods: {
    handleDownloadClick: async function (item) {
      if (item.__t === "AutoDiagJob") {
        window.open(
        process.env.VUE_APP_API_EXT_URL +
        "/job/getRes/" +
        item._id +
        "?tkn=" +
        localStorage.getItem("jwt"),
        "_blank"
      );
      } else {
        window.location.assign(
        process.env.VUE_APP_API_EXT_URL +
        "/job/getRes/" +
        item._id +
        "?tkn=" +
        localStorage.getItem("jwt")
      );
      }
    },
    formatDate: function (date) {
      return niceDateTimeFormat(new Date(date));
    },
    getColor(item, state) {
      if (state === "done") {
        return "green";
      }
      if (item == undefined) {
        return "grey";
      }
      if (this.isDateMoreThanTwoDaysFromNow(item)) {
        return "red";
      } else if (this.isDateMoreThanOneDayFromNow(item)) {
        return "orange";
      } else {
        return "green";
      }
    },
    isDateMoreThanNdaysFromNow(inDate, nDays) {
      let dateInMillis = new Date(inDate).getTime();
      let now = Date.now();
      let oneDayInMillis = 24 * 60 * 60 * 1000;
      return now - dateInMillis > oneDayInMillis * nDays;
    },
    isDateMoreThanOneDayFromNow(inDate) {
      return this.isDateMoreThanNdaysFromNow(inDate, 1);
    },
    isDateMoreThanTwoDaysFromNow(inDate) {
      return this.isDateMoreThanNdaysFromNow(inDate, 2);
    },
    async removeJob(item) {
      this.showConfirmDialog = false;
      this.$emit("deleteJob", item)
    }
  },
};
</script>